import { useQuery, UseQueryOptions } from 'react-query';
import { getMerchant } from '@frontend/api-payments';
import { getInterScreenQueryOptions } from '@frontend/payments-hooks';
import { getPaymentsPlatformQueryKey } from '../../utils/query-key';

export type UseMerchantProps = {
  locationId: string;
};

export const USE_LOCATION_MERCHANT_KEY = 'merchant';
export const getUseLocationMerchantQueryKey = (locationId: string, ...extra: any[]) => {
  return getPaymentsPlatformQueryKey(USE_LOCATION_MERCHANT_KEY, locationId, ...extra);
};

export const useLocationMerchant = (
  { locationId }: UseMerchantProps,
  options: UseQueryOptions<Awaited<ReturnType<typeof getMerchant>>> = {}
) => {
  return useQuery({
    queryKey: getUseLocationMerchantQueryKey(locationId),
    queryFn: () => getMerchant(locationId),
    ...getInterScreenQueryOptions(),
    ...options,
    enabled: !!locationId && options.enabled !== false, // Only run the query if locationId is provided
  });
};
